import { Dashboard } from "./Dashboard/Dashboard";

export const DashboardPage = Dashboard;